(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antshq-collection-product-rotator-v1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('antshq-product-rotator')) {
    class AntshqProductRotator extends HTMLElement {
      constructor() {
        super();
        this.timer = null;
        this.currentIndex = 0;
        this.isPaused = false;
        this.handleMouseEnter = this.pause.bind(this);
        this.handleMouseLeave = this.resume.bind(this);
        this.handleFocusIn = this.pause.bind(this);
        this.handleFocusOut = this.handleFocusOut.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-rotator-slide]'));
        this.interval = Number(this.dataset.rotationInterval) || 20000;

        if (this.slides.length <= 1) {
          this.showSlide(0);
          return;
        }

        this.addEventListener('mouseenter', this.handleMouseEnter);
        this.addEventListener('mouseleave', this.handleMouseLeave);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('focusout', this.handleFocusOut);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        this.showSlide(0);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.removeEventListener('mouseenter', this.handleMouseEnter);
        this.removeEventListener('mouseleave', this.handleMouseLeave);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      }

      start() {
        this.stop();

        if (this.slides.length <= 1 || this.isPaused || document.hidden) {
          return;
        }

        this.timer = window.setInterval(() => {
          this.showSlide((this.currentIndex + 1) % this.slides.length);
        }, this.interval);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      pause() {
        this.isPaused = true;
        this.stop();
      }

      resume() {
        this.isPaused = false;
        this.start();
      }

      handleFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
          this.resume();
        }
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.stop();
        } else if (!this.isPaused) {
          this.start();
        }
      }

      showSlide(index) {
        if (!this.slides.length) {
          return;
        }

        this.currentIndex = Math.max(0, Math.min(index, this.slides.length - 1));

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === this.currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          slide.querySelectorAll('[data-rotator-focusable]').forEach((element) => {
            element.tabIndex = isActive ? 0 : -1;
          });
        });
      }
    }

    customElements.define('antshq-product-rotator', AntshqProductRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antshq-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-antshq-carousel-wrap]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-antshq-carousel]');
    var hint = wrap.querySelector('[data-antshq-swipe-hint]');
    var prevBtn = wrap.querySelector('[data-antshq-nav="prev"]');
    var nextBtn = wrap.querySelector('[data-antshq-nav="next"]');
    if (!track) return;
    function cardStep() {
      var card = track.querySelector('.antshq-collection-card');
      if (!card) return track.clientWidth;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }
    if (!hint) return;
    function positionHint() {
      var firstImage = wrap.querySelector('.antshq-collection__image-wrap');
      if (!firstImage) return;
      var wrapTop = wrap.getBoundingClientRect().top;
      var imageRect = firstImage.getBoundingClientRect();
      var centerY = (imageRect.top - wrapTop) + (imageRect.height / 2);
      hint.style.top = centerY + 'px';
      hint.style.transform = 'translateY(-50%)';
    }
    function maybeShowHint() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var overflows = track.scrollWidth > track.clientWidth + 4;
      if (isMobile && overflows && track.scrollLeft <= 1) {
        hint.classList.add('is-visible');
      } else {
        hint.classList.remove('is-visible');
      }
    }
    function dismissHint() {
      hint.classList.add('is-hidden');
      hint.classList.remove('is-visible');
      track.removeEventListener('scroll', dismissHint);
    }
    track.addEventListener('scroll', dismissHint, { once: true });
    window.addEventListener('resize', function () {
      positionHint();
      maybeShowHint();
    });
    window.addEventListener('load', function () {
      positionHint();
      maybeShowHint();
    });
    positionHint();
    maybeShowHint();
    setTimeout(function () {
      positionHint();
      maybeShowHint();
    }, 300);
  });
  // Keep both purchase forms and the visible price in sync with the selected variant.
  // Delegation also covers section instances re-rendered in Shopify's theme editor.
  document.addEventListener('change', function (event) {
    var picker = event.target;
    if (!picker || !picker.matches('.antshq-collection [data-antshq-card-variant]')) return;
    var card = picker.closest('[data-antshq-purchase-card]');
    if (!card) return;
    var option = picker.options[picker.selectedIndex];
    if (!option) return;
    var available = option.getAttribute('data-available') === 'true';
    var compare = option.getAttribute('data-compare') || '';

    card.querySelectorAll('.antshq-collection-card__form input[name="id"]').forEach(function (input) {
      input.value = option.value;
    });

    var price = card.querySelector('[data-antshq-card-price]');
    if (price) price.textContent = option.getAttribute('data-price') || '';
    var compareElement = card.querySelector('[data-antshq-card-compare]');
    if (compareElement) {
      compareElement.textContent = compare;
      compareElement.hidden = !compare;
    }

    var buyButton = card.querySelector('.antshq-collection-card__buy');
    if (buyButton) {
      buyButton.disabled = !available;
      buyButton.textContent = available
        ? buyButton.getAttribute('data-antshq-buy-label')
        : buyButton.getAttribute('data-antshq-sold-out-label');
    }
    var addButton = card.querySelector('.antshq-collection-card__add');
    if (addButton) addButton.disabled = !available;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antshq-testimonials-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-antshq-testi-wrap]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-antshq-testi-track]');
    var prevBtn = wrap.querySelector('[data-antshq-testi-nav="prev"]');
    var nextBtn = wrap.querySelector('[data-antshq-testi-nav="next"]');
    if (!track) return;

    function cardStep() {
      var card = track.querySelector('.antshq-testi-card');
      if (!card) return track.clientWidth;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    var hint = wrap.querySelector('[data-antshq-testi-swipe-hint]');
    if (!hint) return;

    function positionHint() {
      var firstCard = track.querySelector('.antshq-testi-card');
      if (!firstCard) return;
      var wrapTop = wrap.getBoundingClientRect().top;
      var cardRect = firstCard.getBoundingClientRect();
      var verticalOffset = 72;
      var centerY = (cardRect.top - wrapTop) + (cardRect.height / 2) + verticalOffset;
      hint.style.top = centerY + 'px';
      hint.style.transform = 'translateY(-50%)';
    }
    function maybeShowHint() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var overflows = track.scrollWidth > track.clientWidth + 4;
      if (isMobile && overflows && track.scrollLeft <= 1) {
        hint.classList.add('is-visible');
      } else {
        hint.classList.remove('is-visible');
      }
    }

    function dismissHint() {
      hint.classList.add('is-hidden');
      hint.classList.remove('is-visible');
      track.removeEventListener('scroll', dismissHint);
    }

    track.addEventListener('scroll', dismissHint, { once: true });
    window.addEventListener('resize', function () {
      positionHint();
      maybeShowHint();
    });
    window.addEventListener('load', function () {
      positionHint();
      maybeShowHint();
    });

    positionHint();
    maybeShowHint();
    setTimeout(function () {
      positionHint();
      maybeShowHint();
    }, 300);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antshq-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-antshq-testi-wrap]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-antshq-testi-track]');
    var prevBtn = wrap.querySelector('[data-antshq-testi-nav="prev"]');
    var nextBtn = wrap.querySelector('[data-antshq-testi-nav="next"]');
    if (!track) return;
    function cardStep() {
      var card = track.querySelector('.antshq-testi-card');
      if (!card) return track.clientWidth;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }
    var hint = wrap.querySelector('[data-antshq-testi-swipe-hint]');
    if (!hint) return;
    function positionHint() {
      var firstCard = track.querySelector('.antshq-testi-card');
      if (!firstCard) return;
      var wrapTop = wrap.getBoundingClientRect().top;
      var cardRect = firstCard.getBoundingClientRect();
      var verticalOffset = 72;
      var centerY = (cardRect.top - wrapTop) + (cardRect.height / 2) + verticalOffset;
      hint.style.top = centerY + 'px';
      hint.style.transform = 'translateY(-50%)';
    }
    function maybeShowHint() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var overflows = track.scrollWidth > track.clientWidth + 4;
      if (isMobile && overflows && track.scrollLeft <= 1) {
        hint.classList.add('is-visible');
      } else {
        hint.classList.remove('is-visible');
      }
    }
    function dismissHint() {
      hint.classList.add('is-hidden');
      hint.classList.remove('is-visible');
      track.removeEventListener('scroll', dismissHint);
    }
    track.addEventListener('scroll', dismissHint, { once: true });
    window.addEventListener('resize', function () {
      positionHint();
      maybeShowHint();
    });
    window.addEventListener('load', function () {
      positionHint();
      maybeShowHint();
    });
    positionHint();
    maybeShowHint();
    setTimeout(function () {
      positionHint();
      maybeShowHint();
    }, 300);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
